var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceboook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-brands:facebook-square",
    clipPath: "url(#clip0_1268_880)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4286 1.71436H2.57143C1.88944 1.71436 1.23539 1.98527 0.753154 2.46751C0.270918 2.94975 0 3.6038 0 4.28578L0 23.1429C0 23.8249 0.270918 24.479 0.753154 24.9612C1.23539 25.4434 1.88944 25.7144 2.57143 25.7144H9.92411V17.5549H6.54911V13.7144H9.92411V10.7872C9.92411 7.45775 11.9063 5.61864 14.9421 5.61864C16.3961 5.61864 17.9164 5.87793 17.9164 5.87793V9.14578H16.2413C14.5907 9.14578 14.0759 10.1701 14.0759 11.2206V13.7144H17.7605L17.1712 17.5549H14.0759V25.7144H21.4286C22.1106 25.7144 22.7646 25.4434 23.2468 24.9612C23.7291 24.479 24 23.8249 24 23.1429V4.28578C24 3.6038 23.7291 2.94975 23.2468 2.46751C22.7646 1.98527 22.1106 1.71436 21.4286 1.71436Z",
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27.4286,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceboook);
export default __webpack_public_path__ + "static/media/faceboook.11d8bfab623e5ca83ddf1415790b501b.svg";
export { ForwardRef as ReactComponent };